import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../Assets/images/brown-logo.svg";
import styles from "./login.module.css";
import PrimaryButton from "../../Components/Buttons/PrimaryButton";

const Forgotpassword = () => {
	return (
		<>
			<div className={styles.loginWrapper}>
				<div className={styles.loginCard}>
					<Link to="/" className={styles.formLogo}>
						<img src={Logo} alt="Natureland" />
					</Link>
					<form>
						<div className={styles.formHeader}>
							<h1>Forgot password</h1>
							<p>Please enter your registered email address</p>
						</div>
						<div className="formElements">
							<div className="formGroup">
								<label className="formLabel">Email</label>
								<input
									className={`${styles.formControl} form-control`}
									type="email"
									placeholder="Enter Email"
								/>
							</div>
							<PrimaryButton
								text="Submit"
								type="submit"
								className={styles.AuthButton}
							/>
							<div className={styles.bottomLink}>
								<Link to="/login" className={styles.linkText}>
									Or Sign In instead
								</Link>
							</div>
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default Forgotpassword;
